import ResourceScreen from "@/components/ResourceScreen";
import { PageHeader } from "@/components/kit";

const RECORD_STATUS = ["active", "inactive", "archived"];
const opts = (v) => v.map((x) => ({ value: x, label: x[0].toUpperCase() + x.slice(1) }));

const CONFIG = {
  key: "suppliers", title: "Suppliers", singular: "Supplier", module: "procurement",
  endpoint: "/admin-dashboard/suppliers",
  filters: [{ key: "status", label: "Status", options: opts(RECORD_STATUS) }],
  columns: [
    { key: "code", label: "Code" }, { key: "name", label: "Name" },
    { key: "contact_person", label: "Contact" }, { key: "email", label: "Email" },
    { key: "phone", label: "Phone" }, { key: "status", label: "Status" },
  ],
  fields: [
    { key: "code", label: "Code", required: true },
    { key: "name", label: "Name", required: true },
    { key: "contact_person", label: "Contact Person" },
    { key: "email", label: "Email" },
    { key: "phone", label: "Phone" },
    { key: "address", label: "Address", type: "textarea" },
    { key: "tax_id", label: "Tax ID" },
    { key: "lead_time_days", label: "Lead Time (days)", type: "number" },
    { key: "status", label: "Status", type: "select", options: opts(RECORD_STATUS), default: "active" },
  ],
};

export default function Suppliers() {
  return (
    <div className="space-y-6" data-testid="suppliers-page">
      <PageHeader title="Suppliers" subtitle="Procurement-owned supplier directory." />
      <ResourceScreen config={CONFIG} />
    </div>
  );
}
